"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _style = require("../utils/style");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  animation-delay: -0.16s;\n\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  animation-delay: -0.32s;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  animation-delay: -0.48s;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  margin-top: calc(50% -  ", " / 2);\n  background-color: ", ";\n  border-radius: 100%;\n  display: inline-block;\n  animation: ", " ", "s infinite ease-in-out;\n  animation-fill-mode: both;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 150px;\n  height: 150px;\n  text-align: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  0%,\n  80%,\n  100% {\n    -webkit-transform: scale(0);\n  }\n  40% {\n    -webkit-transform: scale(1);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var bouncedelay = (0, _styledComponents.keyframes)(_templateObject());

var LoadingContainer = _styledComponents.default.div(_templateObject2());

var load = _styledComponents.default.div(_templateObject3(), function (props) {
  return _style.sizeItem[props.size] || _style.sizeItem['default'];
}, function (props) {
  return _style.sizeItem[props.size] || _style.sizeItem['default'];
}, function (props) {
  return _style.sizeItem[props.size] || _style.sizeItem['default'];
}, function (props) {
  return props.color || '#00adb5';
}, bouncedelay, function (props) {
  return props.speed || 1.4;
});

var LoadFirst = (0, _styledComponents.default)(load)(_templateObject4());
var LoadTwo = (0, _styledComponents.default)(load)(_templateObject5());
var LoadThree = (0, _styledComponents.default)(load)(_templateObject6());

var TransverseLoading = function TransverseLoading(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? _style.commonStyle : _ref$style,
      color = _ref.color,
      speed = _ref.speed,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "default" : _ref$size;
  return _react.default.createElement(LoadingContainer, {
    style: style
  }, _react.default.createElement(LoadFirst, {
    color: color,
    size: size,
    speed: speed
  }), _react.default.createElement(LoadTwo, {
    color: color,
    size: size,
    speed: speed
  }), _react.default.createElement(LoadThree, {
    color: color,
    size: size,
    speed: speed
  }));
};

var _default = TransverseLoading;
exports.default = _default;